import { ApplicantsTable } from './ApplicantsTable';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { ApolloError } from '@apollo/client';

type Props = {
  onSubscriptionError?: (error: ApolloError) => void;
};

export const ApplicantsTab: React.FC<Props> = ({ onSubscriptionError }) => {
  const organization = useOrganization();

  return (
    <ApplicantsTable
      organizationId={organization.id}
      onSubscriptionError={onSubscriptionError}
    />
  );
};
